import { c as _c } from "react/compiler-runtime";
import { useRevalidateModules } from '@systemeio/util';
import { useEffect } from 'react';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';

/**
 * A job row polls its own status, so the notifications list and the unread flag still hold the
 * running state once the job ends. Refetching them then updates the Unread tab and the dots.
 */
export const useRevalidateNotificationsOnJobEnd = hasPolledJobEnded => {
  const $ = _c(4);
  const {
    revalidateModules
  } = useRevalidateModules();
  let t0;
  let t1;
  if ($[0] !== hasPolledJobEnded || $[1] !== revalidateModules) {
    t0 = () => {
      if (hasPolledJobEnded) {
        revalidateModules([RequestModuleEnum.Notifications]);
      }
    };
    t1 = [hasPolledJobEnded, revalidateModules];
    $[0] = hasPolledJobEnded;
    $[1] = revalidateModules;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
};